import { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Alert,
} from "@mui/material";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

export default function PaymentFieldBuilderComponent({
  dataFormFields,
  fieldMeta,
  setFieldMeta,
  initialMeta,
}) {
  const [mode, setMode] = useState("fixed"); // fixed | open | computed
  const [amount, setAmount] = useState("");
  const [sourceFields, setSourceFields] = useState([]);

  const koboToNaira = (kobo) => {
    return (Number(kobo || 0) / 100).toFixed(2);
  };

  const nairaToKobo = (naira) => {
    return Math.round(Number(naira || 0) * 100);
  };

  useEffect(() => {
    console.log(initialMeta);
    if (initialMeta) {
      if (initialMeta.mode) setMode(initialMeta.mode);
      if (initialMeta.amount) setAmount(initialMeta.amount);
      if (initialMeta.source_fields) setSourceFields(initialMeta.source_fields);
    }
  }, [initialMeta]);

  useEffect(() => {
    let config = { mode };

    if (mode === "fixed") {
      config.amount = Number(amount || 0);
    }

    if (mode === "computed") {
      config.source_fields = sourceFields;
    }

    setFieldMeta({
      ...fieldMeta,
      payment_field: config,
    });
  }, [mode, amount, sourceFields]);

  return (
    <MDBox mt={3}>
      <MDTypography variant="h6" fontSize={14}>
        Payment Configuration
      </MDTypography>

      <MDBox mt={3}>
        <FormControl fullWidth>
          <InputLabel>Payment Mode</InputLabel>
          <Select
            value={mode}
            label="Payment Mode"
            onChange={(e) => setMode(e.target.value)}
            sx={{ padding: "12px", paddingLeft: "3px" }}
          >
            <MenuItem value="fixed">Fixed Amount</MenuItem>
            <MenuItem value="open">Open Amount (User enters)</MenuItem>
            <MenuItem value="computed">Computed (Sum of fields)</MenuItem>
          </Select>
        </FormControl>
      </MDBox>

      {/* FIXED */}
      {mode === "fixed" && (
        <MDBox mt={3}>
          <MDInput
            type="number"
            label="Amount"
            fullWidth
            value={amount ? amount / 100 : ""}
            onChange={(e) => {
              setAmount(Number(e.target.value || 0) * 100);
            }}
          />
        </MDBox>
      )}

      {mode === "computed" && (
        <MDBox mt={3}>
          <FormControl fullWidth>
            <InputLabel>Source Fields</InputLabel>

            <Select
              multiple
              label="Source Fields"
              value={sourceFields}
              onChange={(e) => setSourceFields(e.target.value)}
              renderValue={(selected) =>
                selected
                  .map((ref) => dataFormFields.find((f) => f.reference === ref)?.display_name)
                  .join(", ")
              }
              sx={{ padding: "12px", paddingLeft: "3px" }}
            >
              {dataFormFields
                .filter((f) =>
                  ["number", "amount", "decimal_number", "formula_field"].includes(
                    f.data_field?.field_type
                  )
                )
                .map((field) => (
                  <MenuItem key={field.reference} value={field.reference}>
                    <Checkbox checked={sourceFields.includes(field.reference)} />
                    <MDTypography variant="body2" fontSize={14}>
                      {field.section} - {field.display_name}
                    </MDTypography>
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <MDBox mt={3}>
            <Alert severity="info">
              <MDTypography variant="body2">
                Selected fields will be summed to determine payment amount.
              </MDTypography>
            </Alert>
          </MDBox>
        </MDBox>
      )}

      {mode === "open" && (
        <MDBox mt={3}>
          <Alert severity="info">
            <MDTypography variant="body2">
              User will enter the amount during form submission.
            </MDTypography>
          </Alert>
        </MDBox>
      )}
    </MDBox>
  );
}
